import {
  Component,
  EventEmitter,
  Input,
  Output
  } from '@angular/core';
import { TreeNode } from 'primeng/primeng';

@Component({
  selector: 'nec-folder-tree',
  templateUrl: './nec-folder-tree.component.html',
  styleUrls: ['./nec-folder-tree.component.scss']
})
export class NecFolderTreeComponent {
  @Output() nodeSelect = new EventEmitter<TreeNode>();
  @Input() data: TreeNode[];
  private curActiveTreeNode: TreeNode;

  @Input()
  set activeFolder(activeFolder: TreeNode) {
    this.setCurActiveTreeNode(activeFolder, false);
  }

  constructor() { }

  onNodeSelect(node: TreeNode) {
    // éå¤ç¹å»å½åactiveå¶å­èç¹, æ æä½, ç´æ¥è¿å
    if (this.curActiveTreeNode === node) {
      return;
    }
    // ç¹å»äºå¶ä»èç¹, åæ¢å½åactiveèç¹
    else {
      this.setCurActiveTreeNode(node);
    }
  }


  // åæ¢å½åactiveèç¹, å¹¶å¹¿æ­ç¸å³äºä»¶
  private setCurActiveTreeNode(node: TreeNode, emitEvent = true) {
    if (!node) {
      return;
    }

    if (this.curActiveTreeNode) {
      this.curActiveTreeNode.styleClass = '';
    }

    this.curActiveTreeNode = node;
    node.styleClass = 'active';
    node.expanded = true;
    if (emitEvent) {
      this.nodeSelect.emit(node);
    }

    // å±å¼ææç¶æä»¶å¤¹
    let nodeCopy: TreeNode = Object.create(node);
    while (nodeCopy.parent) {
      nodeCopy.parent.expanded = true;
      nodeCopy = nodeCopy.parent;
    }
  }
}
